<div class="    flex  pt-[72px]  ">
  <!-- [ngClass]="{'main_glass': isSS}"  -->
  <div class="aspect-square	  w-full rounded-3xl" (click)="open()">
    <img [src]="gImg(0)" alt="gallery image 1 main image window"  class="   rounded-xl  cursor-pointer	" style=" ">

  </div>

  <div *ngIf="images.size>=2" (click)="reArrImages(gImg(1))" class="aspect-square	anim1  cursor-pointer	backdrop-blur-sm  w-1/4 relative "
    style="position: absolute; top: 0px; left: 0px;">
    <div class="relative w-full h-full image_card rounded-xl ">


      <img [src]="gImg(1)" class="rounded-xl shadow aspect-square contain" alt="gallery image   2"  style="position: absolute; object-fit: contain;">
      <img src="../../../../assets/graphics/glare1.png" alt="gallery image glare 2"  class="aspect-square rounded-xl shadow w-full h-full"
        style="position: absolute;  ">


    </div>
  </div>


  <div *ngIf="images.size>=3" (click)="reArrImages(gImg(2))" class="aspect-square anim2  cursor-pointer	backdrop-blur-sm 	 relative  w-1/4"
    style="position: absolute; bottom: 0px;  left: -10%;">
    <div class="relative w-full h-full image_card rounded-xl ">


      <img [src]="gImg(2)" class="rounded-xl shadow contain aspect-square"  alt="gallery image   3" style="position: absolute; object-fit: contain">
      <img src="../../../../assets/graphics/glare1.png" alt="gallery image glare 3"  class="aspect-square rounded-xl shadow w-full h-full"
        style="position: absolute;  ">


    </div>
  </div>


  <div class="aspect-square	 relative  w-[15%] xs:w-[10%] sm:w-[15%] anim3    "
    style="position: absolute; bottom: 50%;  right: 0%;">
    <div class="relative w-full h-full image_card rounded-xl   ">

      <img src="../../../../assets/graphics/glare1.png" alt="gallery image glare  "  class=" rounded-xl shadow w-full h-full"
        style="position: absolute;  ">


    </div>
  </div>


  <div class="aspect-square	 relative  w-[9%] xs:w-[9%] sm:w-[11%] anim2    "
    style="position: absolute; bottom: 44%;  right: -6%;">
    <div class="relative w-full h-full image_card rounded-xl   ">

      <img src="../../../../assets/graphics/glare1.png" alt="gallery image glare  "  class=" rounded-xl shadow w-full h-full"
        style="position: absolute;  ">


    </div>
  </div>





  <div *ngIf="images.size>=4" (click)="reArrImages(gImg(3))" class="aspect-square  anim2 backdrop-blur-sm cursor-pointer	 relative w-1/4"
    style="position: absolute;  bottom: -5%; left: 10%; ">
    <div class="relative w-full h-full image_card rounded-xl ">


      <img [src]="gImg(3)" class="rounded-xl shadow aspect-square" alt="gallery image   4"  style="position: absolute; object-fit: contain">
      <img src="../../../../assets/graphics/glare1.png" alt="gallery image glare 4"  class="aspect-square rounded-xl  shadow w-full h-full"
        style="position: absolute;  ">


    </div>
  </div>


  <div *ngIf="images.size>=5" (click)="reArrImages(gImg(4))" class="aspect-square  anim2  cursor-pointer	backdrop-blur-sm 	 relative w-1/4"
    style="position: absolute; top: -5%; right: 10%;">
    <div class="relative w-full h-full image_card rounded-xl ">


      <img [src]="gImg(4)" class="rounded-xl shadow aspect-square" alt="gallery image   5"  style="position: absolute; object-fit: contain">
      <img src="../../../../assets/graphics/glare1.png" alt="gallery image glare 5"  class="aspect-square rounded-xl shadow w-full h-full"
        style="position: absolute;  ">


    </div>

  </div>

  <div *ngIf="images.size===6" (click)="reArrImages(gImg(5))" alt="gallery image 5"  class="aspect-square  	 anim3  cursor-pointer	backdrop-blur-sm  relative  w-1/4"
    style="position: absolute; bottom: -10%; right: -8%;">
    <div class="relative w-full h-full image_card rounded-xl ">


      <img [src]="gImg(5)"  alt="gallery image 6" class="rounded-xl shadow aspect-square" style="position: absolute; object-fit: contain">
      <img src="../../../../assets/graphics/glare1.png"  alt="gallery image glare 6"  class="aspect-square shadow rounded-xl  w-full h-full"
        style="position: absolute;  ">


    </div>

  </div>
  <!---->
</div>
<!-- <p style="text-align: center; color: #ff4d06;">Click to enlarge</p> -->
